import React from 'react';
import { Location } from 'utils/Location';
import { ToastContainer } from 'react-toastify';

import Router from './Routes';
import ErrorHandler from './components/error/ErrorHandler';

const App = () => {
  // Expose Location to Cypress to be able to stub the assign method
  if (window.Cypress) {
    window.Location = Location;
  }

  return (
    <ErrorHandler>
      <ToastContainer
        hideProgressBar
        draggable
        pauseOnHover
      />
      <Router />
    </ErrorHandler>
  );
};

export default App;
